import cx from "classnames";
import { CircleSpinner } from "common/spinners";
import React from "react";
import styles from "./layoutComponents.scss";

const PROD = "ridewithgps.com";

export const AdminLayout = ({ children, title, loading, readonly, narrow }) => (
  <>
    {!readonly && window.location.host === PROD && <div className={styles.prodWarn}>Currently Editing Production</div>}
    <div className={cx(styles.AdminLayout, narrow && styles.narrow)}>
      <h1>{title}</h1>
      {loading ? <Loading /> : children}
      <div className={styles.suggestionBox}>
        Something you want added to this page? Make a GitHub issue and tag @eichelbw.
      </div>
    </div>
  </>
);

const Loading = () => (
  <div style={{ textAlign: "center", marginTop: "50px" }}>
    <CircleSpinner size={25} />
  </div>
);

export const Grid = ({ children, cols = 3 }) => (
  <div className={styles.Grid} style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
    {children}
  </div>
);
